import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "./Login.css";
import logo from "../assets/images/logo.png";
import {
  FaMobileAlt,
  FaLock,
  FaEye,
  FaEyeSlash,
  FaArrowRight,
} from "react-icons/fa";

function Login() {
  const [showPassword, setShowPassword] = useState(false);
  // const [mobile, setMobile] = useState("");
  // const [password, setPassword] = useState("");
  const [mobile, setMobile] = useState("9300000000");
  const [password, setPassword] = useState("123456");

  const [error, setError] = useState({});
  const navigate = useNavigate();

  /* ═══════════════════════════════════════
     AUTO LOGIN VIA URL PARAMS (from file 1)
     ═══════════════════════════════════════ */
  useEffect(() => {
    const autoLogin = async () => {
      const queryParams = new URLSearchParams(window.location.search);
      const mobileParam = queryParams.get("mobile");
      const passwordParam = queryParams.get("pssword"); // Note: Typo "pssword"

      if (mobileParam && passwordParam) {
        try {
          const response = await fetch(
            `${process.env.REACT_APP_API_URL}/loginAssociateChannel`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                mobile: mobileParam,
                password: passwordParam,
              }),
            }
          );

          const data = await response.json();

          if (response.ok && data.success === "1") {
            localStorage.setItem("isLoggedIn", "true");
            localStorage.setItem("token", data.token);
            localStorage.setItem("username", data.data.username);

            const username = data.data.username;
            const sentenceCaseName =
              username.charAt(0).toUpperCase() +
              username.slice(1).toLowerCase();

            Swal.fire({
              title: "Login Successful!",
              html: `Welcome : ${sentenceCaseName}`,
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              timerProgressBar: true,
            }).then(() => {
              window.location.href = "/dashboard";
            });

            setError({});
          } else {
            let errorMessage = "Invalid mobile or password.";
            if (data.message === "not exist or inactive") {
              errorMessage =
                "Your account is blocked. Please contact admin.";
            }
            setError({ form: errorMessage });
          }
        } catch (err) {
          console.error("Login Error:", err);
          setError({ form: "Something went wrong. Try again later." });
        }
      }
    };

    autoLogin();
  }, []);

  /* ═══════════════════════════════════════
     ALREADY LOGGED IN REDIRECT (from file 1)
     ═══════════════════════════════════════ */
  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    const token = localStorage.getItem("token");

    if (isLoggedIn === "true" && token) {
      navigate("/dashboard");
    }
  }, [navigate]);

  const togglepasswordshow = () => {
    setShowPassword((prev) => !prev);
  };

  /* ═══════════════════════════════════════
     FORGOT PASSWORD — CONTACT ADMIN ALERT
     ═══════════════════════════════════════ */
  const handleForgotPassword = (e) => {
    e.preventDefault();
    Swal.fire({
      title:
        '<span style="color: #0d1b4c; font-weight: 800;">Forgot Password?</span>',
      html: `
      <div style="padding: 10px 0; font-family: 'Poppins', sans-serif;">
        <div style="
          width: 70px;
          height: 70px;
          margin: 0 auto 16px;
          background: linear-gradient(135deg, #e63946, #c1121f);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 10px 25px rgba(230, 57, 70, 0.35);
        ">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
          </svg>
        </div>
        <p style="font-size: 15px; color: #475569; line-height: 1.6; margin: 0 0 8px; font-weight: 500;">
          For security reasons, please contact our <strong style="color:#e63946;">Admin</strong> to reset your password.
        </p>
        <p style="font-size: 13px; color: #94a3b8; margin: 0;">
          Our team will help you regain access quickly.
        </p>
      </div>
    `,
      showConfirmButton: true,
      confirmButtonText: "Got it",
      confirmButtonColor: "#e63946",
      customClass: {
        popup: "custom-swal-forgot",
        confirmButton: "custom-swal-confirm",
      },
      width: "380px",
      padding: "28px 24px",
    });
  };

  /* ═══════════════════════════════════════
     VALIDATION
     ═══════════════════════════════════════ */
  const validate = () => {
    let tempErrors = {};
    let isValid = true;

    if (!mobile) {
      tempErrors.mobile = "Mobile number is required";
      isValid = false;
    } else if (!/^[6-9]\d{9}$/.test(mobile)) {
      tempErrors.mobile = "Enter valid 10-digit mobile number";
      isValid = false;
    }

    if (!password) {
      tempErrors.password = "Password is required";
      isValid = false;
    } else if (password.length < 6) {
      tempErrors.password = "Password must be at least 6 characters";
      isValid = false;
    }

    setError(tempErrors);
    return isValid;
  };

  /* ═══════════════════════════════════════
     API LOGIN (Associate Channel API from file 1)
     ═══════════════════════════════════════ */
  const handleLogin = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/loginAssociateChannel`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ mobile, password }),
        }
      );

      const data = await response.json();

      if (response.ok && data.success == "1") {
        // Login success
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("token", data.token);
        localStorage.setItem("username", data.data.username);

        const username = data.data.username;
        const sentenceCaseName =
          username.charAt(0).toUpperCase() + username.slice(1).toLowerCase();

        Swal.fire({
          title: "Login Successful!",
          html: `Welcome : ${sentenceCaseName}`,
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
          timerProgressBar: true,
        }).then(() => {
          window.location.href = "/dashboard";
        });

        setError({});
      } else {
        // Error message logic
        let errorMessage = "Invalid mobile or password.";

        if (data.message === "not exist or inactive") {
          errorMessage = "Your account is blocked. Please contact admin.";
        }

        setError({ form: errorMessage });
      }
    } catch (err) {
      console.error("Login Error:", err);
      setError({ form: "Something went wrong. Try again later." });
    }
  };

  return (
    <div className="login-page">
      {/* ═══════════ LEFT SIDE — Branding ═══════════ */}
      <div className="login-left">
        <div className="login-left-overlay"></div>
        <div className="login-left-content">
          <Link to="/" className="login-brand">
            <img src={logo} alt="A2 Demo" />
          </Link>
          <h1>
            Welcome to <span>A2 Demo Real Estates Associates Panel</span>
          </h1>
          <p>Your Trusted Partner in Real Estate</p>

          <ul className="login-features">
            <li>✓ Verified Properties</li>
            <li>✓ RERA Approved Projects</li>
            <li>✓ Trusted by 1000+ Associates</li>
          </ul>
        </div>
      </div>

      {/* ═══════════ RIGHT SIDE — Login Form ═══════════ */}
      <div className="login-right">
        <div className="login-form-wrapper">
          <div className="login-header">
            <h2>
              Associates <span>Login</span>
            </h2>
            <p>Login to access your dashboard</p>
          </div>

          <form onSubmit={handleLogin} className="login-form">
            {/* Mobile Number */}
            <div className="login-input-group">
              <label>Mobile Number</label>
              <div className="login-input-wrapper">
                <FaMobileAlt className="login-input-icon" />
                <input
                  type="text"
                  name="mobile"
                  placeholder="Enter your 10-digit mobile"
                  value={mobile}
                  maxLength="10"
                  onChange={(e) => {
                    if (/^\d*$/.test(e.target.value)) {
                      setMobile(e.target.value);
                    }
                  }}
                  required
                />
              </div>
              {error.mobile && (
                <small className="login-error">{error.mobile}</small>
              )}
            </div>

            {/* Password */}
            <div className="login-input-group">
              <label>Password</label>
              <div className="login-input-wrapper">
                <FaLock className="login-input-icon" />
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="login-toggle-password"
                  onClick={togglepasswordshow}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              {error.password && (
                <small className="login-error">{error.password}</small>
              )}
            </div>

            {/* Options */}
            <div className="login-options">
              <label className="login-remember">
                <input type="checkbox" defaultChecked /> Remember me
              </label>
              <button
                type="button"
                className="login-forgot"
                onClick={handleForgotPassword}
              >
                Forgot Password?
              </button>
            </div>

            {/* Form Error */}
            {error.form && <p className="login-error-form">{error.form}</p>}

            {/* Submit */}
            <button type="submit" className="login-btn-submit">
              Login <FaArrowRight />
            </button>
          </form>

        </div>
      </div>
    </div>
  );
}

export default Login;
